// Fullscreen-quad passthrough: positions are already in NDC (planeGeometry [2,2])
// so we bypass the modelView/projection matrices entirely.
export const PASSTHROUGH_VERT = /* glsl */ `
  varying vec2 vUv;
  void main() {
    vUv = uv;
    gl_Position = vec4(position.xy, 0.0, 1.0);
  }
`
